import { useSelector } from 'react-redux';
import { Modal } from '../CommonUIComponents/Modal/Modal';
import './FileVersionHistoryModal.scss';
import { RepeatIcon } from '../../icons/repeat';
import {
  fileVersionHistoryModalHeaderDate,
  fileVersionHistoryModalHeaderFileName,
  fileVersionHistoryModalHeaderUploadedBy,
  manageEmissionBodyUploadFileHistory,
  fileVersionHistoryModalLiveVersion,
} from '../../util/constants';
import { Table } from '../CommonUIComponents/Table/Table';
import { formarDateTime } from '../../util/dateUtil';
import { customCellRenderer } from './cutomCellRenderer';
import { MotifChip } from '../../assets/lib/motif';

function ModalHeader() {
  return (
    <div className="file-version-history-modal-header">
      <div className="motif-fab">
        <RepeatIcon />
      </div>
      <span>{manageEmissionBodyUploadFileHistory}</span>
    </div>
  );
}

function ModalBody() {
  const fileHistory = useSelector(state => state.engagement.fileUploadHistory);
  const fileHistoryLoading = useSelector(
    state => state.engagement.fileUploadHistoryLoading
  );

  return (
    <div>
      <Table
        rowData={fileHistory}
        colDefs={[
          {
            field: 'uploadDate',
            filter: true,
            headerName: fileVersionHistoryModalHeaderDate,
            headerTooltip: fileVersionHistoryModalHeaderDate,
            maxWidth: 150,
            suppressMovable: true,
            valueFormatter: params => {
              return formarDateTime(params.value, 'dd MMMM yyyy');
            },
          },
          {
            field: 'fileName',
            filter: true,
            headerName: fileVersionHistoryModalHeaderFileName,
            headerTooltip: fileVersionHistoryModalHeaderFileName,
            flex: 1,
            suppressMovable: true,
            cellRenderer: params => {
              return (
                <div style={{ display: 'flex' }}>
                  <p>{params.value.length > 60 ? params.value.substring(0,60) + '... ' : params.value} &nbsp;</p>
                  {params.node.data.liveVersion && (
                    <MotifChip
                      label="Live"
                      className="file-version-history-modal-live-chip"
                    >
                      {fileVersionHistoryModalLiveVersion}
                    </MotifChip>
                  )}
                </div>
              );
            },
          },
          {
            field: 'email',
            filter: true,
            headerName: fileVersionHistoryModalHeaderUploadedBy,
            headerTooltip: fileVersionHistoryModalHeaderUploadedBy,
            flex: 1,
            suppressMovable: true,
            minWidth: 200,
          },
          {
            field: 'liveVersion',
            headerName: '',
            filter: true,
            cellRenderer: customCellRenderer,
            maxWidth: 200,
            suppressMovable: true,
          },
        ]}
        draggable={false}
        loading={fileHistoryLoading}
      />
    </div>
  );
}

export function FileVersionHistoryModal({ isModalVisible, onClose }) {
  return (
    <Modal
      show={isModalVisible}
      onClose={onClose}
      header={<ModalHeader />}
      body={<ModalBody />}
      size={'xl'}
      className={'file-version-history-modal'}
    />
  );
}
